import styled from '@emotion/styled';
import { createStyles } from '@material-ui/core/styles';
import { ErrorMessage } from 'formik';

import { ICustomTheme } from 'interfaces';

export const CheckboxesContainer = styled.div<{ theme: ICustomTheme }>`
  padding-left: ${({ theme }) => theme.spacing(2)}px;
`;

export const InputsContainer = styled.div<{ theme: ICustomTheme }>`
  margin-top: ${({ theme }) => `${theme.spacing(2)}px`};
  width: 100%;
  > div {
    width: 100%;
  }
`;

export const InputsInline = styled.div<{ theme: ICustomTheme }>`
  display: flex;
  justify-content: space-around;
  width: 100%;
  gap: ${({ theme }) => `${theme.spacing(3)}px`};
`;

export const StyledErrorMessage = styled(ErrorMessage)<{ theme: ICustomTheme }>`
  color: ${({ theme }) => theme.colors.error.main};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  margin-top: 2rem;
`;

export const muiStyles = (theme: ICustomTheme) =>
  createStyles({
    label: ({ isMobile }: { isMobile: boolean }) => ({
      color: theme.palette.text.secondary,
      fontSize: isMobile
        ? theme.fontSizes.mobileLabel
        : theme.fontSizes.desktopLabel,
    }),
    tooltip: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(1),
    },
  });
